export default import.meta.ROLLDOWN_FILE_URL_rN_1li4k2aIbHGs0zKW8QQ